import React from 'react';
import { Data } from './Data';
import { Link } from 'gatsby';

function ListingData() {
  return (
    <div className="flex basis-3/4 flex-col justify-around text-sm md:flex-row">
      {Object.entries(Data)
        .slice(0, 5)
        .map((List, index) => (
          <div key={index} className="w-1/2 py-2 font-bold">
            {List[0]}
            {List[1].map((value, index) => (
              <div key={index} className=" mt-2 py-2 md:py-4 md:pr-4">
                <Link
                  to={value.href}
                  state={{ name: value.name.toLowerCase() }}
                  className="cursor-pointer list-none font-medium hover:text-brand"
                >
                  {value.name}
                </Link>
              </div>
            ))}
          </div>
        ))}
    </div>
  );
}

export default ListingData;
